// src/auth/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import auth from "../redux/slices/auth";


export default function ProtectedRoute(Component) {

    return function Wrapped(props) {
        const [loading, setLoading] = useState(true);
        const [signedIn, setSignedIn] = useState(false);

        useEffect(() => {
            let mounted = true;

            const check = async () => {
                try {
                    let usr = await Auth.currentAuthenticatedUser();
                    if (mounted && usr) {
                        setSignedIn(true);
                        setLoading(false);
                    }
                } catch (err) {
                    if (mounted) {
                        setSignedIn(false);
                        setLoading(false);
                    }
                }
            };

            check();
            return () => (mounted = false);
        }, []);

        if (loading) return null; // or a spinner
        if (!signedIn) {
            window.location.href = '/'; // Redirect to login
            return null;
        }

        return <Component {...props} />
    };
}
